import httpService from "app/services/httpService";
import config from "../../../../src/config.json";

const apiUrl = config.apiUrl;

const getBookingHistory = async (query) => {
  const url = `${apiUrl}/flight/book-flight-all${query ? `?${query}` : ""}`;
  const data = await httpService.get(url);
  return data;
};

const bookingDetails = async (id) => {
  //debugger;
  try {
    const { data } = await httpService.post(
      `${apiUrl}/flight/booking-details/${id}`
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};

const changeRequestDetails = async (query) => {
  const url = `${apiUrl}/flight/booked-flight-change-request-list${
    query ? `?${query}` : ""
  }`;
  const data = await httpService.get(url);
  return data;
};

const approveRequestDetails = async (values) => {
  try {
    const { data } = await httpService.post(
      `${apiUrl}/flight/approve-booking-request`,
      values
    );
    // console.log(data);
    return data;
  } catch (error) {
    console.error(error);
  }
};

const declineRequestDetails = async (values) => {
  try {
    const { data } = await httpService.post(
      `${apiUrl}/flight/decline-booking-request`,
      values
    );
    // console.log(data);
    return data;
  } catch (error) {
    console.error(error);
  }
};

const internationalTicketHandler = async (id, withPrice) => {
  try {
    const url = `${apiUrl}/flight/print-ticket/${id}?withPrice=` + withPrice;
    const data = await httpService.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};
const ticketHandler = async (bookingId, withPrice) => {
  try {
    const url =
      `${apiUrl}/flight/tripjack-print-ticket/${bookingId}?withPrice=` +
      withPrice;
    const data = await httpService.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};
const offlineTicketHandler = async (bookingId, withPrice) => {
  try {
    const url =
      `${apiUrl}/flight/admin-print-ticket/${bookingId}?withPrice=` + withPrice;
    const data = await httpService.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};

const refundInvoiceHandler = async (bookingId, withPrice) => {
  try {
    const url =
      `${apiUrl}/flight/tripjack-print-refund-invoice/${bookingId}?withPrice=` +
      withPrice;
    const data = await httpService.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};
const exportBookedFlight = async (queryString) => {
  try {
    const url = `${apiUrl}/flight/book-flight-all/export${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await httpService.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};
const sendTicketInEmail = async (values) => {
  try {
    const { data } = await httpService.post(
      `${apiUrl}/flight/ticket/sendemail/${values}`
    );
    // console.log(data);
    return data;
  } catch (error) {
    console.error(error);
  }
};
const cancelTicketRequested = async (values) => {
  try {
    const data = await httpService.post(
      `${apiUrl}/flight/approve-cancellation-booking-request`,
      values
    );
    console.log(data);
    return data;
  } catch (error) {
    console.error(error);
  }
};

const getCancellationList = async (query) => {
  const url = `${apiUrl}/flight/cancellation-flight-list${
    query ? `?${query}` : ""
  }`;
  const data = await httpService.get(url);
  return data;
};
const exportCancellationList = async (queryString) => {
  try {
    const url = `${apiUrl}/flight/cancellation-flight-list/export${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await httpService.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};
const getBookingDetails = async (id) => {
  // debugger;
  try {
    const data = await httpService.get(`${apiUrl}/flight/booked-flight/${id}`);
    return data;
  } catch (error) {
    console.error(error);
  }
};
const getFlightMarkup = async (id) => {
  // debugger;
  try {
    const data = await httpService.get(
      `${apiUrl}/flightcarrier/active-carrier-commission`
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};
const insuranceType = async (id) => {
  // debugger;
  try {
    const data = await httpService.post(`${apiUrl}/mihuru/insurance-type`);
    return data;
  } catch (error) {
    console.error(error);
  }
};
const insurance = async (values) => {
  try {
    const data = await httpService.post(`${apiUrl}/mihuru/insurance`, values);
    console.log(data);
    return data;
  } catch (error) {
    console.error(error);
  }
};

export {
  getCancellationList,
  exportCancellationList,
  getBookingHistory,
  bookingDetails,
  changeRequestDetails,
  approveRequestDetails,
  declineRequestDetails,
  internationalTicketHandler,
  ticketHandler,
  exportBookedFlight,
  sendTicketInEmail,
  cancelTicketRequested,
  getBookingDetails,
  getFlightMarkup,
  offlineTicketHandler,
  insuranceType,
  insurance,
  refundInvoiceHandler,
};
